import React from 'react';
import { Button, ButtonPriority, HoverStyles } from 'wix-ui-tpa/cssVars';
import { useSettings } from '@wix/tpa-settings/react';
import { st, classes } from './LoadMoreButton.st.css';
import { useDailyAgendaActions } from '../../../components/DailyAgenda/hooks/useDailyAgendaActions';
import { useWidgetViewModel } from '../../../components/DailyAgenda/hooks/useWidgetViewModel';
import { Spinner } from '../Spinner/Spinner';
import { BodyDataHooks } from '../../../components/DailyAgenda/Widget/Body/const';
import { WidgetComponents, WidgetElements } from '../../../utils/bi/consts';
import settingsParams from '../../../components/DailyAgenda/settingsParams';

export type LoadMoreButtonProps = {
  className?: string;
};

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  className,
}) => {
  const { loadMoreViewModel } = useWidgetViewModel();
  const settings = useSettings();
  const showLoadMoreButton = settings.get(settingsParams.showLoadMoreButton);
  const { onLoadMore, onElementClicked } = useDailyAgendaActions();
  const { isLoading, buttonText, hasMore } = loadMoreViewModel || {};

  if (!showLoadMoreButton || (!hasMore && !isLoading)) {
    return null;
  }

  const handleLoadMoreClick = () => {
    onLoadMore();
    onElementClicked(
      WidgetComponents.LOAD_MORE,
      WidgetElements.LOAD_MORE_BUTTON,
    );
  };

  return (
    <div className={st(classes.root, className)} data-hook={BodyDataHooks.Main}>
      {isLoading ? (
        <div
          className={classes.spinner}
          data-hook={BodyDataHooks.LoadMoreSpinner}
        >
          <Spinner show={true} />
        </div>
      ) : (
        <Button
          className={classes.loadMoreButton}
          priority={ButtonPriority.secondary}
          onClick={handleLoadMoreClick}
          data-hook={BodyDataHooks.LoadMoreButton}
          hoverStyle={HoverStyles.underline}
          disabled={isLoading}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};
